import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  viewChild,
} from "@angular/core";
import { Application } from "@int/ivaap-app/Application";
import { IVAAPCardType } from "../../models/well.model";
import { NGIVAAPService } from "../../services/ivaap.service";
import ivaap_directives_dashboards from "./ivaap_directives_dashboard.json";
import ivaap_directives_templates from "./ivaap_directives_template.json";

@Component({
  selector: "app-ivaap",
  standalone: true,
  imports: [],
  templateUrl: "./ivaap.component.html",
  styleUrls: ["./ivaap-component.css"],
})
export class IvaapComponent {
  ivaapTemplateId = input("");
  ivaapDatasetIds = input<string[]>([]);
  ivaapType = input<IVAAPCardType | string>(IVAAPCardType.TEMPLATE);

  ivaapSvc = inject(NGIVAAPService);
  // @ViewChild("ivaapContainer", { static: true }) ivapContainer: any;
  ivaapContainer = viewChild<ElementRef<HTMLDivElement>>("ivaapContainer");
  isIVAAPInitialized = this.ivaapSvc.initialized;
  isIVAAPAuthenticated = this.ivaapSvc.isAuthenticated;
  renderIVAAP = computed(
    () =>
      this.isIVAAPInitialized() &&
      this.isIVAAPAuthenticated() &&
      this.ivaapSvc.IVAAPService &&
      this.ivaapTemplateId(),
  );

  constructor() {
    effect(() => console.log("IVAAP Template ID:", this.ivaapTemplateId()));
    effect(async () => {
      if (this.renderIVAAP() && this.ivaapSvc.IVAAPService) {
        if (Application.getInstance() == null) {
          await this.ivaapSvc.IVAAPService.start("ivaap-container");
          this.ivaapSvc.IVAAPService.hideDataTree();
        } else {
          const container = this.ivaapContainer();
          if (!container) {
            console.error("IVAAP container element not found");
            return;
          }
          this.ivaapSvc.IVAAPService.move(container.nativeElement);
        }

        if (this.ivaapType() === IVAAPCardType.TEMPLATE) {
          for (const directive of ivaap_directives_templates) {
            // If the command is "openTemplate", we need to set the template ID before executing the command
            if (directive.payload.command === "openTemplate") {
              directive.payload.params.id = this.ivaapTemplateId();
            }
            if (
              directive.payload.command === "addDatasets" &&
              directive.payload.params.datasets
            ) {
              directive.payload.params.datasets[0].ids = this.ivaapDatasetIds();
            }
            this.ivaapSvc.IVAAPService.executeUCCommand(
              directive.payload.command as any,
              directive.payload.params,
            );
          }
        }
        else if (this.ivaapType() === IVAAPCardType.DASHBOARD) {
          for (const directive of ivaap_directives_dashboards) {
            // If the command is "openDashboard", we need to set the dashboard ID before executing the command
            if (directive.payload.command === "openDashboard") {
              directive.payload.params.id = this.ivaapTemplateId();
            }
            this.ivaapSvc.IVAAPService.executeUCCommand(
              directive.payload.command as any,
              directive.payload.params,
            );
          }
        }
        //Template directives
      }
    });
  }
}
